const areFollowUpsSameAsPrompts = (followUps, entryPointPrompts) => {
    if (!followUps || !entryPointPrompts || followUps.length !== entryPointPrompts.length) {
        return false;
    }

    const followUpContents = followUps.map(chip => chip?.content).sort();
    const promptContents = entryPointPrompts.map(prompt => prompt?.content).sort();

    return followUpContents.every((content, index) => content === promptContents[index]);
};

export default areFollowUpsSameAsPrompts;
